<script setup lang="ts">
import StandardPage from '@/content-types/standard-page/StandardPage.vue';
import HeroAnalysis from '@/components/analysis-hero/HeroAnalysis.vue';
import useAnalysisPost from '@/content-types/analysis-post/useAnalysisPost';
import { useSeoMeta } from '#app';

const { listPosts } = useAnalysisPost();
const analysisPosts = await listPosts();

useSeoMeta({
  title: 'Analysis | Open Methane',
  ogTitle: 'Analysis | Open Methane',
  description: 'The latest results and analysis of Australia\'s methane emissions.',
  ogDescription: 'The latest results and analysis of Australia\'s methane emissions.',
});
</script>

<template>
  <StandardPage title="News & Analysis">
    <main>
      <HeroAnalysis
        v-for="post in analysisPosts.reverse()"
        :key="post.slug"
        :post-slug="post.slug"
      />
    </main>
  </StandardPage>
</template>

<style scoped lang="scss">

</style>
